import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppState } from '../../app.state';
import {
    AuthenticationService as JwtAuthenticationService,
} from '../../core/services/authentication/authentication.service';
import {
    DDAgreementBetaDialogComponent,
} from '../../delivery-defense/dd-agreement-beta-dialog/dd-agreement-beta-dialog.component';
import { Feature } from '../models/feature.enum';

@Injectable({
    providedIn: 'root',
})
export class BetaFeatureService {
    private isDDAgreementBetaDialogOpen = false;

    public constructor(private route: ActivatedRoute,
                       private readonly jwtAuthenticationService: JwtAuthenticationService,
                       private readonly appState: AppState,
                       private readonly dialog: MatDialog,
    ) {
    }

    public checkOnRefresh(): void {
        this.jwtAuthenticationService.isLoggedIn().subscribe(
            (isLoggedIn) => {
                if (isLoggedIn) {
                    this.checkBetaPreferences(this.appState.customer$()?.CustomerId);
                }
            },
        );
    }

    public checkBetaPreferences(customerId: string): void {
        const featureAction = {
            [Feature.DeliveryDefense]: this.handleDeliveryDefenseBeta.bind(this),
        };

        this.getCustomerPendingAgreementBetaFeatures(customerId)
            .subscribe((features) => {
                for (const feature of features) {
                    if (!featureAction[feature]) {
                        continue;
                    }

                    featureAction[feature]();
                }
            });
    }

    public getCustomerPendingAgreementBetaFeatures(customerId: string): Observable<Feature[]> {
        // TODO: Use an actual API request.
        // const endpoint = SafeUrlAssembler()
        //     .template(this.apiEndpointService.getEndpoint('getCustomerPendingAgreementBetaFeatures'))
        //     .toString();
        // return this.httpClientService.get<Feature[]>(endpoint);

        //#region TEMP - Hardcode for testing purpose.
        if (this.appState.customer$()?.DDEnabled === false) {
            return of([Feature.DeliveryDefense]);
        }

        const betaFeatureCustomers: Partial<{ [key in Feature]: string[]; }> = {
            [Feature.DeliveryDefense]: ['DUMMY'],
            [Feature.DigitalWallet]: ['MUMMY'],
        };

        const customerFeatures = (Object.keys(betaFeatureCustomers) as unknown as Feature[])
            .filter(key => betaFeatureCustomers[key]?.includes(customerId?.toString() || ''));

        return of(customerFeatures);
        //#endregion
    }

    private handleDeliveryDefenseBeta(): void {
        const isDDEnabledCustomer = this.appState.customer$()?.DDEnabled !== null;
        const isUSUser = this.appState.user$()?.CountryCode === 'US';
        const shouldAllowDeliveryDefenseBeta = isUSUser && isDDEnabledCustomer;

        if (!shouldAllowDeliveryDefenseBeta) {
            return;
        }

        const isDDBetaTermsAccepted = this.appState.customer$()?.DDEnabled === true;
        const shouldShowBetaDDAgreement = !isDDBetaTermsAccepted;
        if (shouldShowBetaDDAgreement) {
            this.openDDAgreementBetaDialog();
        }
    }

    private openDDAgreementBetaDialog(): void {
        if (this.isDDAgreementBetaDialogOpen) {
            return;
        }

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(DDAgreementBetaDialogComponent, dialogConfig);
        this.isDDAgreementBetaDialogOpen = true;

        dialogRef.afterClosed().subscribe(() => {
            this.isDDAgreementBetaDialogOpen = false;
            this.appState.customer$().DDEnabled = true;
            // this.sharedService.customerSubject.next(this.sharedService.currentCustomer);
        });
    }
}
